import history from './history';

// Replaces react-router-scroll (removed in react-router v5): remember the window
// scroll position per history entry and restore it on back/forward (POP); scroll
// to top on a new navigation (PUSH/REPLACE). Call once; returns an unlisten fn.
const positions = {};

const keyOf = location => location.key || 'root';

export const installScrollRestoration = () => {
    if (typeof window === 'undefined') {
        return () => {};
    }
    if ('scrollRestoration' in window.history) {
        // Manage restoration ourselves — the browser's native restoration is
        // unreliable with client-side routing (the page isn't painted yet).
        window.history.scrollRestoration = 'manual';
    }

    let lastKey = keyOf(history.location);

    return history.listen((location, action) => {
        // window.scrollY is still the outgoing page's scroll here (React hasn't
        // re-rendered yet), so record where the user was before moving on.
        positions[lastKey] = window.scrollY;
        lastKey = keyOf(location);

        // Apply AFTER the new route renders (double rAF), for both restore (POP)
        // and scroll-to-top (PUSH/REPLACE). react-router-scroll also ran
        // post-render, so its scroll overrode any scrollIntoView a page did on
        // mount (e.g. VirtualSection's "scroll to broadcast"). Scrolling
        // synchronously on PUSH fired before render and failed to override it,
        // so sessions opened via "JOIN NOW" wrongly scrolled down.
        const y = action === 'POP' ? (positions[lastKey] || 0) : 0;
        requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)));
    });
};
